// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import { Validator } from 'vee-validate'
import { sync } from 'vuex-router-sync'

// Import of configuration / creation code created.
import plugins from './config/plugins'
import directives from './config/directives'
import validations from './config/validations'
import configRouter from './config/router'
import vuexStore from './vuex/store'
import vuetify from './plugins/vuetify'

plugins(Vue, Vuex, VueRouter)
directives(Vue)
// theme(Vue)
validations(Validator)

const store = new Vuex.Store(vuexStore)
const router = configRouter(VueRouter)

// Synchronization between routes and vuex.
// Ensures store status on all SPA pages.
sync(store, router)

// Importing the root component where the app will be rendered.
import App from './App' // eslint-disable-line

// Redirect to login page if token is not saved
router.beforeEach((to, from, next) => {
  if (!store.state.isLogged && !(to.path === '/login')) {
    next('/login')
  }
  return next()
})

new Vue({ // eslint-disable-line no-new
  vuetify,
  router,
  store,
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js